import { jsx as _jsx } from "react/jsx-runtime";
import { CloudOff, SearchX } from 'lucide-react';
import { Button } from "./button.js";
import { EmptyState, Spinner } from "./feedback.js";
const DEFAULT_FAILURE = 'O servidor não respondeu. Isto não quer dizer que a lista esteja vazia — quer dizer que o Aeris não conseguiu lê-la.';
/**
 * O motivo, quando o erro diz qual foi (F144).
 *
 * "O servidor não respondeu" para tudo escondia dois casos que se resolvem de
 * jeitos diferentes: muitas consultas ao mesmo tempo (429, espere) e este
 * computador sem caminho até o servidor (o `server_unreachable` do desktop,
 * olhe a internet). O kit não conhece o `ApiError` da web, então lê só
 * `status` e `code`.
 */
export const loadFailureDescription = (error) => {
    if (typeof error === 'object' && error !== null) {
        if ('status' in error && error.status === 429) {
            return 'Muitas consultas ao mesmo tempo. Tente de novo em alguns segundos.';
        }
        if ('code' in error && error.code === 'server_unreachable') {
            return 'Este computador não conseguiu falar com o servidor Aeris. Confira a internet e tente de novo.';
        }
        /*
         * O servidor RESPONDEU, e dizer "não respondeu" mandava procurar o defeito
         * na rede. O 401 do cookie que o desktop perdia e um 403 de senha a trocar
         * apareciam iguais a uma queda. O status vai junto, para o suporte.
         */
        if ('status' in error && typeof error.status === 'number') {
            if (error.status >= 500) {
                return `O servidor falhou ao responder (erro ${String(error.status)}). Tente de novo; se continuar, avise o suporte.`;
            }
            if (error.status >= 400 &&
                'message' in error &&
                typeof error.message === 'string' &&
                error.message.length > 0) {
                return `${error.message} (erro ${String(error.status)})`;
            }
        }
        // A resposta chegou, mas não no formato que esta tela conhece.
        if ('name' in error && error.name === 'ZodError') {
            return 'A resposta do servidor veio num formato que esta tela não reconhece. Atualize a página (Ctrl+Shift+R); se continuar, avise o suporte.';
        }
    }
    return DEFAULT_FAILURE;
};
export const LoadFailed = ({ what, onRetry, error, }) => (_jsx(EmptyState, { icon: _jsx(CloudOff, { "aria-hidden": "true", className: "h-8 w-8" }), title: `Não foi possível carregar ${what}`, description: loadFailureDescription(error), action: onRetry === undefined ? undefined : (_jsx(Button, { type: "button", variant: "secondary", onClick: onRetry, children: "Tentar de novo" })) }));
export const QueryState = ({ isPending, isError, error, onRetry, what, isEmpty, filtered = false, onClearFilters, empty, children, }) => {
    if (isPending) {
        return (_jsx("div", { className: "flex justify-center py-12", children: _jsx(Spinner, { label: `Carregando ${what}` }) }));
    }
    if (isError) {
        return (_jsx(LoadFailed, { what: what, error: error, ...(onRetry ? { onRetry } : {}) }));
    }
    if (isEmpty && filtered) {
        return (_jsx(EmptyState, { icon: _jsx(SearchX, { "aria-hidden": "true", className: "h-8 w-8" }), title: "Nenhum resultado para este filtro", description: "Mude a busca ou os filtros para ver outros registros.", action: onClearFilters === undefined ? undefined : (_jsx(Button, { type: "button", variant: "secondary", onClick: onClearFilters, children: "Limpar filtros" })) }));
    }
    if (isEmpty)
        return empty;
    return children;
};
//# sourceMappingURL=query-state.js.map